export default "__VITE_ASSET__viPmVFxI__"